import apiConfig from "constants/apiConfig"
import { CollaborationChatRoom } from "types/campaign/collaborations/chat";
import axiosClient from "utils/axiosClient"

export const getBackendTokenForFirebase = async (agencyId: string) : Promise<string> => {
    try {
        const response = await axiosClient.post(apiConfig.CREATE_FIREBASE_TOKEN.url.replace('<agencyId>', agencyId));
        return response.data.token;
    } catch (error) {
        console.error("Failed to fetch firebase custom token", error);
        throw error;
    }
}


export const fetchChatList = async (filters: any) => {
    const response = await axiosClient.get(apiConfig.FETCH_CHATS_LIST.url, {params: filters});
    return response.data;
}


export const getCollabChatRoom = async (
    agencyId: string,
    campaignId: string,
    influencerId: string
): Promise<CollaborationChatRoom> => {
    const response = await axiosClient.post(
        apiConfig.COLLAB_CHAT_ROOM.url
            .replace('<agencyId>', agencyId)
            .replace('<campaignId>', campaignId)
            .replace('<influencerId>', influencerId)
    )
    return response.data;
}